import {TableHeaderInterface} from "../../../../interfaces/TableHeaderInterface";

const headers : Array<TableHeaderInterface> = [
    {
        label: "#",
        className: "w-5p"
    },
    {
        label: "Email",
        sort: 'email',
        className: "w-20p"
    },
    {
        label: "Company",
        className: "w-15p"
    },
    {
        label: "Agreement No",
        sort: 'account_number',
        className: "w-15p"
    },
    {
        label: "Version",
        className: "w-10p"
    },
    {
        label: "Status",
        className: "w-10p"
    },
    {
        label: "Switch",
        className: "w-10p"
    },
    {
        label: "Actions",
        className: "w-10p"
    },
]

export const UserConfig = {
    headers,
}
